/* eslint-disable class-methods-use-this */
import $ from 'jquery';
import 'slick-carousel';
import { forceLazyLoad } from '../global/helpers';
import { breakpoints } from './variables';

const spotlightBreakpoint = breakpoints.sm;

class SpotlightCarousel {
	constructor(el) {
		this.$el = $(el);
		this.$el.slick();

		forceLazyLoad(el);

		// Store reference to the slick instance for quick access.
		this.slick = this.$el.slick('getSlick');
		// Store all slides, including cloned ones.
		this.$slides = $('.slick-slide', this.$el);

		this.handleSetPosition = this.handleSetPosition.bind(this);
		this.$el.on('setPosition', this.handleSetPosition);

		this.handleBeforeChange = this.handleBeforeChange.bind(this);
		this.$el.on('beforeChange', this.handleBeforeChange);

		this.handleAfterChange = this.handleAfterChange.bind(this);
		this.$el.on('afterChange', this.handleAfterChange);
	}

	handleSetPosition() {
		this.updateSlideDimensions();
		this.updateArrowPosition();
	}

	handleBeforeChange(e, slick, current, next) {
		const $currentSlide = $('.slick-current', this.$el);
		let $nextSlide;

		// Check if the next index is the first or last slide, and then get the cloned slide that represents it.
		if (next === 0) {
			$nextSlide = $currentSlide.next();
		} else if (next === this.slick.$slides.length - 1) {
			$nextSlide = $currentSlide.prev();
		}

		// Remove the slick-quick class from other slides.
		$('.slick-quick').removeClass('slick-quick');

		// Add class to $nextSlide if it exists so we can apply the same styles as .slick-current.
		// Slick removes .slick-current from .slick-cloned slides, so you need to use something different here.
		if ($nextSlide) {
			$nextSlide.addClass('slick-quick');
		}
	}

	handleAfterChange() {
		// Remove the slick-quick class from all slides.
		$('.slick-quick').removeClass('slick-quick');
	}

	updateSlideDimensions() {
		this.$slides.height('auto');
		if (spotlightBreakpoint.aboveMin()) {
			this.$slides.height(`${this.slick.$slideTrack.height()}px`);
		}
	}

	updateArrowPosition() {
		let arrowTop;
		if (spotlightBreakpoint.aboveMin()) {
			const $next = $('.slick-current + .slick-slide', this.$el);
			const $nextMedia = $('.em-spotlight-item__media', $next);
			arrowTop = $next.outerHeight() - (($next.outerHeight() - $nextMedia.innerHeight()) / 2);
		} else {
			const $currentMedia = $('.slick-current .em-spotlight-item__media', this.$el);
			arrowTop = $currentMedia.outerHeight() / 2;
		}
		this.slick.$prevArrow.css('top', `${arrowTop}px`);
		this.slick.$nextArrow.css('top', `${arrowTop}px`);
	}
}

const spotlightCarousels = {
	SpotlightCarousels: [],
	init() {
		const carousels = document.querySelectorAll('.js-em-spotlight-carousel');
		if (carousels.length > 0) {
			carousels.forEach((carousel) => {
				this.SpotlightCarousels.push(new SpotlightCarousel(carousel));
			});
		}
	},
};

spotlightCarousels.init();
